<template>
  <div class="special-home">
    <Winners></Winners> 
    <div class="new-games">
      <div class="container">
        <h3 v-if="slotGames.length>0"><b>Yeni Oyunlarımıza</b> Göz Atın!</h3>
        <swiper v-if="slotGames.length>0" :options="!isMobile ? swiperOptionSlot : ''">
              <swiper-slide  v-for="(item,key) in slotGames" :key="key">
                <router-link :to="'/' + item.url">
                  <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
                </router-link>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <Loader v-else ></Loader>
      </div>
    </div>
    <div class="under-s">
      <div class="container">
        <div class="home-navs navigator">
          <router-link to="/sportsbook">
            <i class="icon sport"></i>
            SPOR
          </router-link>
          <router-link to="/casino">
            <i class="icon casino"></i>
            CASINO
          </router-link>
          <router-link to="/slot">
            <i class="icon slot"></i>
            SLOT
          </router-link>
          <router-link to="/virtual">
            <i class="icon virtual"></i>
            SANAL
          </router-link>
          <router-link to="/aviator">
            <i class="icon aviator"></i>
            AVIATOR
          </router-link>
          <router-link to="/zeppelin">
            <i class="icon zeppelin"></i>
            ZEPLİN
          </router-link>
          <router-link to="/jetx">
            <i class="icon jetx"></i>
            JETX
          </router-link>
          <router-link to="/beton">
            <i class="icon poker"></i>
            POKER
          </router-link>
        </div>
      </div>
      <div class="container">
        <div class="j-c">
          <div class="l">
          <swiper v-if="leftSlider.length>0" :options="swiperOptionLeft">
              <swiper-slide  v-for="(item,key) in leftSlider" :key="key">
                <router-link :to="'/' + item.url">
                  <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
                </router-link>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="c">
          <h1><b>Favori</b> Casino Oyunları</h1>
          <div class="banners">
            <div class="col" v-for="item in casinoGames">
                <router-link :to="'/' + item.url">
                  <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
                </router-link>
            </div>
          </div>
        </div>
        <div class="r">
          <swiper v-if="rightSlider.length>0" :options="swiperOptionLeft">
              <swiper-slide  v-for="(item,key) in rightSlider" :key="key">
                <router-link :to="'/' + item.url">
                  <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
                </router-link>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        </div>
      </div>
    </div>
    <div class="container">
        <Jackpot style="width: 100%; padding: 10px 0px 20px 0;" v-if="egt_show"/>
    </div>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import Jackpot from '../Common/Jackpot'
  import Game from '../Casino/Game'
  import UserLogin from '../../views/Auth/Login'
  import Winners from '../Common/Winners'
  export default {
    components:{
      Game,
      UserLogin,
      Winners,
      Jackpot
    },
    data() {
      return {
        rightSlider:[],
        partners:[],
        leaguesList:[],
        newSlot: [],
        loginModal: false,
        isLoadingCasino: false,
        isLoadingWinners: false,
        isLoadingSlot: false,
        isLoadingEvents: false,
        swiperOptionWinners: {
					speed: 500,
          slidesPerView: 4,
          autoplay: {
            delay: 2000,
					},
          navigation: {
            nextEl: '.winner-swiper-button-next',
            prevEl: '.winner-swiper-button-prev'
          }
        },
        swiperOptionLeft: {
					speed: 1500,
          slidesPerView: 1,
          effect: 'cube',
          grabCursor: true,
          cubeEffect: {
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94
          },
          autoplay: {
            delay: 2000,
					},
          navigation: {
            nextEl: '.casino-swiper-button-next',
            prevEl: '.casino-swiper-button-prev'
          }
        },
        swiperOptionSlot: {
          slidesPerView: !this.isMobile ? 4 : 2,
          slidesPerGroup: 1,
          speed: 1000,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 2500,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          coverflowEffect: {
            modifier: 1,
          },
          effect: 'coverflow',
          grabCursor: true,
        },
        casinoGames:[],
        slotGames:[],
        leftSlider:[]
      }
    },
    mounted(){
      
    },
    created(){
      setTimeout(() => {
        this.fetchData()
      }, 1000);
      this.fetchSlot()
    },
    methods:{
      fetchSlot(){
			  return axios.get('games/slot')
        .then((response) => {
          this.newSlot = _.filter(response.data.games, ['provider', 'pragmaticplay']);
        })
        .catch((err) => {
        });
      },
      fetchData: function() {
          this.isLoadingWinners = true,
          this.isLoadingCasino = true,
          this.isLoadingSlot = true,
          this.isLoadingEvents = true,
          this.$store.dispatch('getBanner', ['home', 'both', 'right'])
          .then(response =>{ 
            this.rightSlider = _.sortBy(response.data, ['sort']);
            this.isLoadingEvents = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'bottom'])
          .then(response =>{
            this.casinoGames = _.sortBy(response.data, ['sort'])
            this.isLoadingCasino = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'top'])
          .then(response =>{
            this.slotGames = _.sortBy(response.data, ['sort'])
            this.isLoadingSlot = false; 
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'left'])
          .then(response =>{
            this.leftSlider = _.sortBy(response.data, ['sort'])
            this.isLoadingWinners = false;
          });
          
          setTimeout(() => {
            this.isLoadingEvents = true;
          }, 1000);
          setTimeout(() => {
            this.isLoadingEvents = false;
          }, 1500);
      },
    },
    computed:{
      egt_show(){
        if(this.locale == 'TR' && this.user && this.user.balance > 0){
          return true
        }else{
          return false
        }
      },
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
      user(){
        return this.$user();
      },
      cdn_url(){
        return this.$store.getters['getCdnUrl'];
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      locale(){
          return this.$store.getters.getLocale;
      },
      specialTemplate(){
          return this.$store.getters.getSpecialTemplate;
      }
    },
  }
</script>